module.exports = __webpack_public_path__ + "2d2fe98f4724e8d3c30ceb65395f0964.png";